// mainNavBlur JS, adds blur and darkens body when megamenu is open.
// Components for this are in three separate files:
// datarobot/wp-content/themes/datarobot6/views/base.twig - includes .siteMain__overlay
// datarobot/wp-content/themes/datarobot6/views/header.twig - includes .siteHeader
// datarobot/wp-content/themes/datarobot6/views/blocks/header/menu.twig - actual menu items

// controller for adding .blur class when main desktop submenus are open
document.addEventListener("DOMContentLoaded", function () {
	const body = document.body;

	// Function to toggle the .blur class based on whether any dropdown is open
	function toggleBlurClass() {
		const isOpen = document.querySelector(".uk-navbar-dropdown.uk-open");
		if (isOpen) {
			body.classList.add("blur");
		} else {
			body.classList.remove("blur");
		}
	}

	// Add event listeners for hover and click events on dropdown menus
	document.querySelectorAll(".uk-navbar-dropdown").forEach((dropdown) => {
		dropdown.addEventListener("mouseenter", toggleBlurClass);
		dropdown.addEventListener("mouseleave", toggleBlurClass);

		// Listen for dropdown open/close events
		const observer = new MutationObserver(() => toggleBlurClass());
		observer.observe(dropdown, { attributes: true, attributeFilter: ["class"] });
	});

	// Remove .blur class when navigating away from the page
	window.addEventListener("pagehide", () => body.classList.remove("blur"));
});

// this is to flip the colors of the buttons in the main nav when the hero background is purple or green
// modified to allow hero elements loaded in vue components have time to appear before adding color flip
// this also adds "uk-light" class to navigation if there is a .addUkLightToHeader div present
document.addEventListener("DOMContentLoaded", () => {
	const navigation = document.querySelector(".siteHeader__navigation");
	const addUkLightToHeader = document.querySelector(".addUkLightToHeader");

	const observer = new MutationObserver(() => {
		const heroSection = document.querySelector(".heroSection");
		const productHero = document.querySelector(".productHero");

		// Check conditions and add classes
		if ((heroSection && (heroSection.classList.contains("-green") || heroSection.classList.contains("-purple") || heroSection.classList.contains("-gray"))) || (productHero && (productHero.classList.contains("-green") || productHero.classList.contains("-purple") || productHero.classList.contains("-gray")))) {
			navigation?.classList.add("-buttonColorFlip");
			observer.disconnect(); // Stop observing once the class is added
		}

		// Add uk-light class if addUkLightToHeader is present
		if (addUkLightToHeader && !navigation.classList.contains("uk-active")) {
			navigation?.classList.add("uk-light");
		}
	});

	observer.observe(document.body, { childList: true, subtree: true });

	// Function to toggle uk-light class on scroll
	const handleScroll = () => {
		const scrollTop = window.scrollY;

		if (addUkLightToHeader) {
			if (scrollTop === 0) {
				// Add uk-light back at the top of the page
				navigation.classList.add("uk-light");
			} else if (navigation.classList.contains("uk-active")) {
				// Remove uk-light when uk-active is present
				navigation.classList.remove("uk-light");
			}
		}
	};

	// Initial check on load
	handleScroll();

	// Listen for scroll events
	window.addEventListener("scroll", handleScroll);
});
